"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.parse-int.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.keys.js");

require("sk-ui/lib/theme-chalk/src/base.css");

require("sk-ui/lib/theme-chalk/src/sk-form-verify.css");

var _formVerify = _interopRequireDefault(require("sk-ui/lib/form-verify"));

require("element-ui/lib/theme-chalk/src/base.css");

require("element-ui/lib/theme-chalk/src/form-item.css");

var _formItem2 = _interopRequireDefault(require("element-ui/lib/form-item"));

var _index = require("./index");

var _lodash = _interopRequireDefault(require("lodash"));

var _skAxios = require("sk-axios");

var _util = require("sk-ui/lib/utils/util.js");

var _vue = _interopRequireDefault(require("vue"));

var _lang = _interopRequireDefault(require("@/lang"));

_vue["default"].use(_formItem2["default"]);

_vue["default"].use(_formVerify["default"]); // const _SkFormVerify = SkFormVerify;
// export SkFormVerify;


var _validator = {
  ipAddrReg: /^(?:(?:1[0-9][0-9]\.)|(?:2[0-4][0-9]\.)|(?:25[0-5]\.)|(?:[1-9][0-9]\.)|(?:[0-9]\.)){3}(?:(?:1[0-9][0-9])|(?:2[0-4][0-9])|(?:25[0-5])|(?:[1-9][0-9])|(?:[0-9]))$/,
  prefix2mask: function prefix2mask(prefix) {
    var i;
    var j;
    var mask;
    var k;
    var value;
    var maskBits = '';

    for (i = 0; i < Math.min(prefix, 32); i++) {
      maskBits += '1';
    }

    for (j = prefix; j < 32; j++) {
      maskBits += '0';
    }

    mask = '';

    for (k = 0; k < 32; k += 8) {
      value = parseInt(maskBits.substr(k, 8), 2);
      mask += value;
      k < 24 && (mask += '.');
    }

    return mask;
  },

  /**
   * net===(net&掩码)校验，net包括ip或mac
   */
  maskAndSubnetValidator: function maskAndSubnetValidator(mask, net, hexadecimal) {
    var maskData, netData;

    try {
      var str = mask.indexOf('.') > -1 ? '.' : ':';
      maskData = mask.split(str);
      netData = net.split(str);
      var isValid = true;

      for (var i = 0; i < maskData.length; i++) {
        var condition = hexadecimal ? (parseInt(netData[i], hexadecimal) & parseInt(maskData[i], hexadecimal)) !== parseInt(netData[i], hexadecimal) : (parseInt(netData[i]) & parseInt(maskData[i])) !== parseInt(netData[i]);

        if (condition) {
          isValid = false;
          break;
        }
      }

      return isValid;
    } catch (e) {
      return false;
    }
  }
};

_formVerify["default"].addRule({
  name: 'checkDuplication',
  type: Object
}, function (checkDuplication, form, curFormItem) {
  return {
    // trigger: 'blur',
    validator: function validator(rule, val, callback) {
      var paramNames = checkDuplication.duplicateParams;
      var duplicateParams = {};
      var immediateValid = true;

      if (paramNames) {
        _lodash["default"].forEach(paramNames, function (param) {
          if (_lodash["default"].isString(param)) {
            duplicateParams[param] = (0, _util.getValueByPath)(form.model, param);
          } else if (_lodash["default"].isPlainObject(param)) {
            for (var key in param) {
              if (Object.prototype.hasOwnProperty.call(param, key)) {
                if (key.indexOf('dependenceParams') >= 0) {
                  if (_lodash["default"].isPlainObject(param[key])) {
                    var needObj = param[key];

                    for (var needKey in needObj) {
                      if (Object.prototype.hasOwnProperty.call(needObj, needKey)) {
                        var value = (0, _util.getValueByPath)(form.model, needObj[needKey]);

                        if (key === 'dependenceParams' && (0, _index.isEmptyObj)(value)) {
                          immediateValid = false;
                        }

                        duplicateParams[needKey] = value;
                      }
                    }
                  }
                } else {
                  // duplicateParams[key] = getValueByPath(form.model, param[key])
                  duplicateParams[key] = param[key];
                }
              }
            }
          }
        });
      } // 从fromModel中获取参数


      if (checkDuplication.paramsFromModel) {
        for (var key in checkDuplication.paramsFromModel) {
          if (Object.prototype.hasOwnProperty.call(checkDuplication.paramsFromModel, key)) {
            duplicateParams[key] = (0, _util.getValueByPath)(form.model, checkDuplication.paramsFromModel[key]);
          }
        }
      }

      if (immediateValid) {
        curFormItem.$parent.isValidating = true;

        if (checkDuplication.formatDuplicateParams) {
          duplicateParams = checkDuplication.formatDuplicateParams(duplicateParams);
        }

        (0, _skAxios.post)(checkDuplication.url, duplicateParams).then(function (result) {
          // checkDuplication.fieldName 匹配后端返回的标识字段(boolean)
          var hasException = result.data.content[checkDuplication.fieldName] || result.data.content.hasDuplication;
          curFormItem.$parent.isValidating = false; // 当异步响应时，如果form-item校验状态已经为error，则抛弃这次异步响应结果

          if (curFormItem.validateState === 'error') {
            return;
          } // curFormItem.checking = false;


          if (hasException) {
            // 后端有返回 errorMsg 则使用errorMsg作为错误提示
            callback(new Error(result.data.content.errorMsg || _lang["default"].t(checkDuplication.errorMessage) || _lang["default"].t('repetitionExists')));
          } else {
            callback();
          }
        })["catch"](function (e) {
          curFormItem.$parent.isValidating = false;
          callback(new Error(_lang["default"].t('checkError')));

          if (e) {
            throw e;
          }
        });
      } else {
        callback();
      }
    }
  };
});

_formVerify["default"].addRule({
  name: 'sameAs',
  type: Object
}, function (sameAs, form, curFormItem) {
  return {
    validator: function validator(rule, val, callback) {
      var sameAsValue = (0, _util.getValueByPath)(form.model, sameAs.sameAsItemId);
      sameAsValue === val ? callback() : callback(new Error(_lang["default"].t(sameAs.errorMessage) || curFormItem.errorMessage));
    }
  };
});

_formVerify["default"].addRule({
  name: 'notSameAs',
  type: Object
}, function (notSameAs, form, curFormItem) {
  return {
    validator: function validator(rule, val, callback) {
      var notSameAsValue = (0, _util.getValueByPath)(form.model, notSameAs.notSameAsItemId);
      notSameAsValue !== val ? callback() : callback(new Error(_lang["default"].t(notSameAs.errorMessage) || curFormItem.errorMessage));
    }
  };
});

_formVerify["default"].addRule({
  name: 'validateFieldItem',
  type: Object
}, function (validateFieldItem, form, curFormItem) {
  return {
    validator: function validator(rule, val, callback) {
      var validateFieldValue = (0, _util.getValueByPath)(form.model, validateFieldItem.validateFieldItemId);

      if (validateFieldItem.isVlaidEmpty || validateFieldValue) {
        form.validateField(validateFieldItem.validateFieldItemId);
      }

      callback();
    }
  };
});

_formVerify["default"].addRule({
  name: 'existVlaueWith',
  type: Object
}, function (existVlaueWith, form, curFormItem) {
  return {
    validator: function validator(rule, val, callback) {
      var res = false; // 校验当前项

      var valres = val;

      if (_lodash["default"].isArray(valres)) {
        valres = valres.length;
      }

      if (_lodash["default"].isObject(valres)) {
        valres = Object.keys(valres).length;
      }

      if (valres) {
        return callback();
      } // 校验其他项


      var item = existVlaueWith.anotherItem;

      for (var i = 0; i < item.length; i++) {
        var value = (0, _util.getValueByPath)(form.model, item[i]);

        if (_lodash["default"].isArray(value)) {
          value = value.length;
        }

        if (_lodash["default"].isObject(value)) {
          value = Object.keys(value).length;
        }

        if (value) {
          res = true;
          break;
        }
      }

      res ? callback() : callback(new Error(_lang["default"].t(existVlaueWith.errorMessage) || curFormItem.errorMessage));
    }
  };
});

_formVerify["default"].addRule('ipRange', function () {
  return {
    validator: function validator(rule, value, callback) {
      if (value && (value.id || value.networkId)) {
        if (value.ip) {
          if (_validator.ipAddrReg.test(value.ip)) {
            if (value.row && value.row.ipPoolArr) {
              var ipRange = value.row.ipPoolArr;
              var inRangeFlag = false;

              for (var i = 0; i < ipRange.length; i++) {
                if ((0, _util.ipRangeCheck)(ipRange[i].ipStart, ipRange[i].ipEnd, value.ip)) {
                  inRangeFlag = true;
                  break;
                }
              }

              if (inRangeFlag) {
                callback();
              } else {
                callback(new Error(_lang["default"].t('form.common_term_ipRangeCheck_valid')));
              }
            } else {
              callback(new Error(_lang["default"].t('form.common_term_ipRange_check')));
            }
          } else {
            callback(new Error(_lang["default"].t('form.common_term_ip_valid')));
          }
        } else {
          callback();
        }
      } else {
        callback();
      }
    }
  };
});

var _default = _validator;
exports["default"] = _default;